import React from "react";
import { formatDDMMYYYYbyYYYYMMDD, userDropdownLabel } from "app/_helpers/helper";
const obj = {
  ro: "Reporting Officer",
  so: "Safety Officer",
  mm: "Mines Manager",
  investigator: "Investigator",
  vto: "VTO",
  scheduler: "Scheduler",
  approver: "Approver",
  reviewer: "Reviewer",
};

const otherDataKey = {
  reviewCompletionDate: "Date",
  reviewCompletionSummary: "Comment",
  review: "Comment",
  reviewDate: "Date",
};
const ViewCommentsComponent = ({ comments, title, showTitle }) => (
  <div className="card p-3">
    {showTitle && (
      <div className="simple-card-title">
        <h3 class="text-capitalize mb-0">{title || "Reviewer Inputs"}</h3>
      </div>
    )}
    <div className="ehsFormWrapper pb-2">
      {comments && comments.length ? (
        <div className="w-100">
          <div>
            <div className="chatsection">
              {comments.map((data, index) => (
                <div key={index} className="chatscreen">
                  <h5>
                    <span>{obj[data.userRoleLabel]} - </span>
                    <span className="chatname">{userDropdownLabel(data.reviewer)}&nbsp;</span>
                    <span className="chattime"> &nbsp;{formatDDMMYYYYbyYYYYMMDD(data.createdAt)}</span>
                  </h5>
                  {/* <p className="mb-0">{data.review}</p> */}
                  {data?.otherData ? (
                    <span>
                      {Object.keys(data?.otherData || {})
                        .filter((d) => otherDataKey[d])
                        .map((d) => {
                          return (
                            <>
                              <span>
                                {otherDataKey[d]}: {data?.otherData[d]}
                              </span>
                              <br />
                            </>
                          );
                        })}
                    </span>
                  ) : (
                    <>
                      <p className="mb-0">Comment: {data?.review}</p>
                      <p className="mb-0">Date: {formatDDMMYYYYbyYYYYMMDD(data?.reviewDate)}</p>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className="text-danger">Not Applicable</div>
      )}
    </div>
  </div>
);

export default ViewCommentsComponent;
